import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/company";

export const Route = createFileRoute("/szolgaltatasi-feltetelek")({
  head: () => ({
    meta: [
      { title: "Szolgáltatási és foglalási feltételek | LAKROSZ Autószerviz" },
      {
        name: "description",
        content:
          "A LAKROSZ Autószerviz szolgáltatási és foglalási feltételei: árajánlat, időpontfoglalás, hozott alkatrész, garancia, fizetés.",
      },
      { name: "robots", content: "index,follow" },
      {
        property: "og:title",
        content: "Szolgáltatási és foglalási feltételek | LAKROSZ Autószerviz",
      },
      {
        property: "og:description",
        content: "Szervizszolgáltatás feltételei, foglalás, hozott alkatrész, garancia és fizetés.",
      },
      { property: "og:url", content: "https://lakroszautoszerviz.com/szolgaltatasi-feltetelek" },
      { property: "og:type", content: "article" },
    ],
    links: [{ rel: "canonical", href: "https://lakroszautoszerviz.com/szolgaltatasi-feltetelek" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalLayout title="Szolgáltatási és foglalási feltételek" subtitle={`Utolsó frissítés: ${COMPANY.lastUpdated}`}>
      <section>
        <h2 className="font-display text-2xl mt-4 mb-3">1. A szolgáltatások jellege</h2>
        <p>
          A LAKROSZ Autószerviz gépjárművek és motorkerékpárok javításával, karbantartásával, diagnosztikájával és
          kapcsolódó szervizszolgáltatásokkal foglalkozik.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">2. Tájékoztató jelleg</h2>
        <p>
          A weboldalon szereplő információk, szolgáltatásleírások és esetleges árak tájékoztató jellegűek, nem
          minősülnek kötelező érvényű ajánlatnak.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">3. Ajánlatadás</h2>
        <p>
          A végleges ár és vállalási határidő a jármű állapotának felmérése, a szükséges munkák és alkatrészek
          meghatározása után kerül pontosításra.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">4. Árak</h2>
        <p>A végleges ár függhet az alábbi tényezőktől:</p>
        <ul className="list-disc pl-6 space-y-1 mt-2">
          <li>jármű típusa</li>
          <li>a hiba jellege</li>
          <li>szükséges munkaórák száma</li>
          <li>alkatrészek ára</li>
          <li>diagnosztikai eredmény</li>
          <li>extra ügyféligények</li>
          <li>előre nem látható hibák</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">5. Időpontfoglalás</h2>
        <p>
          Időpont telefonon, e-mailben vagy a weboldalon található kapcsolatfelvételi űrlapon keresztül egyeztethető. A
          foglalás akkor tekinthető véglegesnek, ha azt a szolgáltató visszaigazolta.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">6. Késés és lemondás</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Az ügyfél köteles időben jelezni, ha nem tud megjelenni a foglalt időpontban.</li>
          <li>Jelentős késés esetén a szolgáltató jogosult az időpont módosítására vagy törlésére.</li>
          <li>Ismételt, indokolatlan meg nem jelenés esetén a szolgáltató megtagadhatja új időpont kiadását.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">7. A jármű állapota</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>A szolgáltató nem felel az előzetesen meglévő hibákért, sérülésekért és kopásokért.</li>
          <li>A javítás során feltárt további hibákról a szolgáltató tájékoztatja az ügyfelet.</li>
          <li>
            Előre nem látható hiba esetén az ár és a vállalási határidő módosulhat, erről a szolgáltató tájékoztatást
            ad.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">8. Hozott alkatrész</h2>
        <p>
          A szolgáltató hozott alkatrész beépítését nem vállalja. A javítási és karbantartási munkák során kizárólag a
          szolgáltató által beszerzett, ellenőrzött alkatrészek kerülhetnek beépítésre. A szolgáltató fenntartja a
          jogot, hogy minden, ügyfél által biztosított alkatrész beépítését indokolás nélkül megtagadja.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">9. Alkatrészrendelés</h2>
        <p>
          Amennyiben az alkatrészt a szolgáltató szerzi be, annak ára, elérhetősége és szállítási ideje befolyásolhatja
          a javítás végleges árát és határidejét.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">10. Járműben hagyott tárgyak</h2>
        <p>
          Az ügyfél köteles a járműből eltávolítani az értéktárgyakat és személyes tárgyakat. A szolgáltató nem vállal
          felelősséget a járműben hagyott tárgyakért.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">11. Próbaút</h2>
        <p>
          A javítás, diagnosztika vagy ellenőrzés részeként szükség lehet próbaútra. A jármű átadásával az ügyfél
          tudomásul veszi, hogy a szolgáltató a szükséges mértékben próbaúton ellenőrizheti a jármű működését.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">12. Garancia / szavatosság</h2>
        <p>
          A szolgáltató az elvégzett munkára a vonatkozó jogszabályok szerint vállal felelősséget. Az alkatrészekre
          vonatkozó garancia az adott alkatrész gyártója vagy forgalmazója által meghatározott feltételek szerint
          érvényesíthető.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">13. Reklamáció</h2>
        <p>
          Reklamációt az ügyfél a szolgáltatás átvételekor vagy a hiba észlelését követően haladéktalanul jelezhet. A
          reklamáció kivizsgálásához szükséges lehet a jármű újbóli bemutatása. Részletes panaszkezelési eljárás a{" "}
          <a className="text-primary underline" href="/panaszkezeles">
            Panaszkezelési tájékoztatóban
          </a>{" "}
          érhető el.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">14. Fizetés</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Készpénz: IGEN</li>
          <li>Bankkártya: IGEN</li>
          <li>Átutalás: IGEN</li>
        </ul>
        <p className="mt-3">A számla kiállítása a hatályos jogszabályok szerint történik.</p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">15. Felelősségi korlát</h2>
        <p>
          A szolgáltató nem vállal felelősséget olyan hibákért vagy károkért, amelyek a jármű korábbi állapotából,
          rejtett hibájából, nem megfelelő korábbi javításából, kopásából vagy az ügyfél által biztosított alkatrész
          hibájából erednek.
        </p>
      </section>

      <section className="text-sm text-muted-foreground mt-8">
        Kapcsolat:{" "}
        <a className="text-primary" href={COMPANY.contact.phoneHref}>
          {COMPANY.contact.phone}
        </a>{" "}
        · 3300 Eger, Vécseyvölgy utca 99.
      </section>
    </LegalLayout>
  );
}
